import { ListResponse } from '@percent/partner-dashboard/common/hooks/useInfiniteQuery/useInfiniteQuery.types'
import { Money } from '@percent/utility'

export enum EmployeeActivityType {
  OPPORTUNITY_CREATED = 'opportunity_created',
  VOLUNTEERED = 'volunteered',
  FUNDRAISER_CREATED = 'fundraiser_created',
  DONATED = 'donated',
  ACHIEVEMENT_EARNED = 'achievement_earned'
}

type EmployeeActivityBase = Readonly<{
  date: string
  iconUrl: string | null
  linkUrl: string | null
}>

type OpportunityCreatedActivity = EmployeeActivityBase &
  Readonly<{
    type: EmployeeActivityType.OPPORTUNITY_CREATED
    data: {
      opportunityName: string
    }
  }>

type VolunteeredActivity = EmployeeActivityBase &
  Readonly<{
    type: EmployeeActivityType.VOLUNTEERED
    data: {
      minutes: number
      opportunityName: string | null
    }
  }>

type FundraiserCreatedActivity = EmployeeActivityBase &
  Readonly<{
    type: EmployeeActivityType.FUNDRAISER_CREATED
    data: {
      fundraiserName: string
    }
  }>

export type PaymentProvider = 'stripe' | 'paypal' | 'donation_wallet' | 'razorpay'

export type DonationFundingSource = Readonly<{
  id: string | null
  name: string | null
  amount: Money
}>

type DonatedActivity = EmployeeActivityBase &
  Readonly<{
    type: EmployeeActivityType.DONATED
    data: {
      amount: Money
      organisationName: string | null
      paymentMethod: PaymentProvider | null
      recurrence: 'monthly' | null
      onPlatform: boolean
      fundingSources: DonationFundingSource[]
    }
  }>

type AchievementEarnedActivity = EmployeeActivityBase &
  Readonly<{
    type: EmployeeActivityType.ACHIEVEMENT_EARNED
    data: {
      achievementName: string
      assignedBy: string | null
    }
  }>

export type EmployeeActivity =
  | OpportunityCreatedActivity
  | VolunteeredActivity
  | FundraiserCreatedActivity
  | DonatedActivity
  | AchievementEarnedActivity

export type UseEmployeeActivityQueryParams = Readonly<{
  accountId: string
  pageSize: number
  type?: (string | null)[] | null
  dateGt?: Date
  dateLt?: Date
  timeWindowInDays?: number
}>

export type ApiResponse = Readonly<
  ListResponse<EmployeeActivity> & {
    nextItemDate?: string
  }
>
